import * as React from "react";
import * as ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  defer,
  Outlet,
  Params,
  RouterProvider,
} from "react-router-dom";
import "rsuite/dist/rsuite-no-reset.min.css";
import "./index.css";
import App from "./App";
import ErrorPage from "./Errors/error-page";
import reportWebVitals from "./reportWebVitals";
import MyProfile from "./ProfileWindow/ProfileWithTopNav";
import NewsCreateWindow from "./ProfileWindow/AdminWindows/NewsEditWindow/NewsCreateWindow";
import NewsItemWindow from "./NewsWindows/NewsItemWindow/NewsItemWindow";
import TaskCreateWindow from "./ProfileWindow/AdminWindows/TaskEditWindow/TaskCreateWindow";
import appStore from "./Stores/AppStore";
import UserLoginWindow from "./ProfileWindow/AuthComponents/UserLoginWindow";
import RequireAuth from "./ProfileWindow/AuthComponents/RequireAuth";
import TaskList from "./ProfileWindow/AdminWindows/TaskListWindow/TaskList";
import { RoleEditWindow } from "./ProfileWindow/AdminWindows/RoleEditWindow/RoleEditWindow";
import { AccessCreateWindow } from "./ProfileWindow/AdminWindows/AccessCreateWindow/AccessCreateWindow";
import AuthProvider from "./ProfileWindow/AuthComponents/AuthProvider";
import { default as NewsListWindowForAll } from "./NewsWindows/NewsListWindow/NewsListWindow";
import { default as NewsListWindowForAdmin } from "./ProfileWindow/AdminWindows/NewsListWindow/NewsListWindow";
import { ModuleCreateWindow } from "./ProfileWindow/AdminWindows/ModuleEditWindow/ModuleCreateWindow";
import LearningPathServerClient from "./ServerClients/LearningPathServerClient";
import { LearningPathResponseApi } from "./DTO/ServerResponseType/LearningPath/LearningPath";
import { TaskDataToCreateResponseApi } from "./DTO/ServerResponseType/Task/TaskDataToCreate";
import ModuleList from "./ProfileWindow/AdminWindows/ModuleListWindow/ModulesWindow";
import ResourcesWindow from "./ProfileWindow/AdminWindows/ResourceListWindow/ResourcesWindow";
import { ResourceCreateWindow } from "./ProfileWindow/AdminWindows/ResourceEditWindow/ResourceCreateWindow";
import FileWindow from "./FileWindow/FileWindow";
import ResourceWindow from "./FileWindow/ResourceWindow/ResourceWindow";
import { DominoApp } from "./TaskWindows/Domino/DominoApp";
import LearningPathList from "./ProfileWindow/AdminWindows/LearningPathListWindow/LearningPathList";
import isId from "./utils/typeGuards/isId";
import { wordsAlgorithm } from "./data/Domino/wordsAlgorithm";
import { wordsDevices } from "./data/Domino/wordsDevices";
import { wordsSpace } from "./data/Domino/wordsSpace";
import { GroupCreateWindow } from "./ProfileWindow/TutorWindows/GroupEditWindow/GroupCreateWindow";
import { GroupWindow } from "./ProfileWindow/TutorWindows/GroupViewWindow/GroupWindow";
import ModulesWindow from "./ProfileWindow/TutorWindows/ModuleListWindow/ModulesWindow";
import { ErrorBoundary } from "react-error-boundary";
import { FerryApp } from "./TaskWindows/Ferry/FerryApp";
import TaskWindowProvider from "./Context/TaskWindowContext";
import TabularTaskApp from "./TaskWindows/TabularTask/TabularTaskApp";
import StripesApp from "./TaskWindows/StripesApp/StripesApp";
import { PictureSet } from "./TaskWindows/StripesApp/Setting_difficulty";
import PyramidApp from "./TaskWindows/PyramidApp/PyramidApp";
import CarrierApp from "./TaskWindows/Carrier/CarrierApp";
import { wordsRace } from "./data/Domino/wordsRace";
import { wordsSnow } from "./data/Domino/wordsSnow";
import vodyanoyRoutes from "./TaskWindows/Vodyanoy/VodyanoyRouts";
import HotelApp from "./TaskWindows/Stevehotel/HotelApp"
import cryptoRoutes from "./TaskWindows/Сrypto/CryptoRouts"
import transposRoutes from "./TaskWindows/Transposition/TransposRouts";
import tablesSecretRouts from "./TaskWindows/TablesSecret/TablesSecretRouts"
import navigatorСodeRoutes from "./TaskWindows/NavigatorСode/NavigatorСodeRouts";
import caesarСipherRoutes from "./TaskWindows/CaesarСipher/CaesarСipherRouts";
import SudokuApp, { SudokuLevel } from "./TaskWindows/Sudoku/SudokuApp";

let FlowchartApp = React.lazy(
  () => import("./TaskWindows/Flowchart/FlowchartApp"),
);
let FlowchartProvider = React.lazy(() => import("./Context/FlowchartContext"));

let loadAllLearningPathsAsync = async (): Promise<
  LearningPathResponseApi[] | never
> => {
  return LearningPathServerClient.sendToGetAllLearningPathsWithResourcesAndModulesAsync();
};

let loadersDataToCreate = (
  loadDataToCreateTask: Promise<TaskDataToCreateResponseApi | null>,
) => {
  return {
    getAllTaskTypesPromise: loadDataToCreateTask.then(
      (dataToCreate) => dataToCreate?.types,
    ),
    getAllTaskTagsPromise: loadDataToCreateTask.then(
      (dataToCreate) => dataToCreate?.tags,
    ),
    getAllTaskExecutorsPromise: loadDataToCreateTask.then(
      (dataToCreate) => dataToCreate?.executors,
    ),
    getAllTaskStatusesPromise: loadDataToCreateTask.then(
      (dataToCreate) => dataToCreate?.statuses,
    ),
  };
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [],
  },
  {
    path: "/login",
    element: <UserLoginWindow />,
    errorElement: <ErrorPage />,
    children: [],
  },
  // {
  //   path: "news/list",
  //   element: <NewsListWindowForAll />,
  //   loader: async () =>
  //     defer({ getAllNewsPromise: appStore.newsStore.loadAllNewsAsync() }),
  // },
  // {
  //   path: "news/one/:newsId",
  //   element: <NewsItemWindow />,
  //   loader: async ({ params }: { params: Params<string> }) => {
  //     if (isId(params.newsId)) {
  //       return defer({
  //         getNewsItemPromise: appStore.newsItemStore.loadNewsItemAsync(
  //           params.newsId
  //         ),
  //         getOtherNewsItemsPromise: appStore.newsStore.loadOtherNewsAsync(
  //           params.newsId
  //         ),
  //       });
  //     }
  //   },
  // },
  // {
  //   path: "profile",
  //   element: (
  //     <RequireAuth>
  //       <MyProfile />
  //     </RequireAuth>
  //   ),
  //   loader: async () =>
  //     defer({
  //       getUserPromise: appStore.userStore.loadUserDataAsync(),
  //       getStudentsPromise:
  //         appStore.groupWindowStore.studentsStore.loadAllStudentsAsync(),
  //     }),
  //   children: [
  //     {
  //       path: "news/create",
  //       element: <NewsCreateWindow />,
  //       loader: async () =>
  //         defer({
  //           getNewsItemPromise: appStore.newsItemStore.loadNewNewsItemAsync(),
  //         }),
  //     },
  //     {
  //       path: "news/list",
  //       element: <NewsListWindowForAdmin />,
  //       loader: async () =>
  //         defer({ getAllNewsPromise: appStore.newsStore.loadAllNewsAsync() }),
  //     },
  //     {
  //       path: "news/update/:newsId",
  //       element: <NewsCreateWindow />,
  //       loader: async ({ params }: { params: Params<string> }) => {
  //         if (isId(params.newsId)) {
  //           return defer({
  //             getNewsItemPromise: appStore.newsItemStore.loadNewsItemAsync(
  //               params.newsId
  //             ),
  //           });
  //         }
  //       },
  //     },
  //     {
  //       path: "task/create",
  //       element: <TaskCreateWindow />,
  //       loader: async () => {
  //         let loadDataToCreateTask =
  //           appStore.taskStore.loadDataToCreateTaskAsync();

  //         return defer({
  //           ...loadersDataToCreate(loadDataToCreateTask),
  //           getAllIllustrationsPromise:
  //             appStore.illustrationsStore.loadAllIllustrationsAsync(),
  //           getTaskPromise: appStore.taskStore.loadNewTask(),
  //         });
  //       },
  //     },
  //     {
  //       path: "task/update/:taskId",
  //       element: <TaskCreateWindow />,
  //       loader: async ({ params }: { params: Params<string> }) => {
  //         if (isId(params.taskId)) {
  //           let loadDataToCreateTask =
  //             appStore.taskStore.loadDataToCreateTaskAsync();
  //           return defer({
  //             ...loadersDataToCreate(loadDataToCreateTask),
  //             getAllIllustrationsPromise:
  //               appStore.illustrationsStore.loadAllIllustrationsAsync(),
  //             getTaskPromise: appStore.taskStore.loadTaskAsync(params.taskId!),
  //           });
  //         }
  //       },
  //     },
  //     {
  //       path: "task/list",
  //       element: <TaskList />,
  //       loader: async () => {
  //         let loadDataToCreateTask =
  //           appStore.taskStore.loadDataToCreateTaskAsync();
  //         return defer({
  //           ...loadersDataToCreate(loadDataToCreateTask),
  //           getAllTasksPromise: appStore.tasksStore.loadAllTasksAsync(),
  //         });
  //       },
  //     },
  //     {
  //       path: "users/update/roles",
  //       element: <RoleEditWindow />,
  //       loader: async () =>
  //         defer({
  //           getAllUsersPromise: appStore.usersStore.loadAllUsersAsync(),
  //         }),
  //     },
  //     {
  //       path: "access/create",
  //       element: <AccessCreateWindow />,
  //       loader: async () =>
  //         defer({
  //           getAllLearningPathsPromise: loadAllLearningPathsAsync(),
  //         }),
  //     },
  //     {
  //       path: "module/list",
  //       element: <ModuleList />,
  //       loader: async () =>
  //         defer({
  //           getAllModulesWithResourcesPromise:
  //             appStore.modulesStore.loadAllModulesWithResourcesAndTasksAsync(),
  //         }),
  //     },
  //     {
  //       path: "module/create",
  //       element: <ModuleCreateWindow />,
  //       loader: async () =>
  //         defer({
  //           getAllResourcesPromise:
  //             appStore.moduleWindowStore.resourcesStore.loadAllResourcesAsync(),
  //           getAllTasksPromise:
  //             appStore.moduleWindowStore.tasksStore.loadAllTasksAsync(),
  //           getModulePromise:
  //             appStore.moduleWindowStore.moduleStore.loadNewModuleAsync(),
  //         }),
  //     },
  //     {
  //       path: "module/update/:moduleId",
  //       element: <ModuleCreateWindow />,
  //       loader: async ({ params }: { params: Params<string> }) => {
  //         if (isId(params.moduleId)) {
  //           return defer({
  //             getAllResourcesPromise:
  //               appStore.moduleWindowStore.resourcesStore.loadAllResourcesAsync(),
  //             getAllTasksPromise:
  //               appStore.moduleWindowStore.tasksStore.loadAllTasksAsync(),
  //             getModulePromise:
  //               appStore.moduleWindowStore.moduleStore.loadModuleWithResourcesAndTasksAsync(
  //                 params.moduleId!
  //               ),
  //           });
  //         }
  //       },
  //       errorElement: <ErrorPage />,
  //     },
  //     {
  //       path: "resource/list",
  //       element: <ResourcesWindow />,
  //       loader: async () => {
  //         return defer({
  //           getAllResourcesPromise:
  //             appStore.resourcesStore.loadAllResourcesAsync(),
  //         });
  //       },
  //     },
  //     {
  //       path: "resource/create",
  //       element: <ResourceCreateWindow />,
  //       loader: async () =>
  //         defer({
  //           getResourceWithContentPromise:
  //             appStore.resourceStore.loadNewResourceAsync(),
  //         }),
  //     },
  //     {
  //       path: "resource/update/:resourceId",
  //       element: <ResourceCreateWindow />,
  //       loader: async ({ params }: { params: Params<string> }) => {
  //         if (isId(params.resourceId)) {
  //           return defer({
  //             getResourceWithContentPromise:
  //               appStore.resourceStore.loadResourceWithContentAsync(
  //                 params.resourceId!
  //               ),
  //           });
  //         }
  //       },
  //     },
  //     {
  //       path: "learning_path/list",
  //       element: <LearningPathList />,
  //       loader: async () => {
  //         return defer({
  //           getAllLearningPathsPromise:
  //             appStore.learningPathWindowStore.learningPathsStore.loadAllLearningPathsWithResourcesAndModulesAsync(),
  //           getAllModules:
  //             appStore.learningPathWindowStore.modulesStore.loadAllModulesAsync(),
  //           getAllResources:
  //             appStore.learningPathWindowStore.resourcesStore.loadAllResourcesAsync(),
  //         });
  //       },
  //     },
  //     {
  //       path: "group/create",
  //       element: <GroupCreateWindow />,

  //       loader: async () =>
  //         defer({
  //           getAllLearningPathsPromise: loadAllLearningPathsAsync(),
  //         }),
  //     },
  //     {
  //       path: "group/one/:groupId",
  //       element: <GroupWindow />,
  //       loader: async ({ params }) => {
  //         if (isId(params.groupId)) return params.groupId;
  //       },
  //     },
  //     {
  //       path: "group/learning_path/one/:groupLearningPathId",
  //       element: <ModulesWindow />,
  //       loader: async ({ params }) => {
  //         if (isId(params.groupLearningPathId))
  //           return params.groupLearningPathId;
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "/river-crossing",
  //   element: (
  //   <TaskWindowProvider>
  //       <FerryApp />
  //   </TaskWindowProvider>
  //   ),
  //   children: [],
  // },
  // {
  //   path: "/table-task",
  //   element: <TabularTaskApp />,
  //   children: [],
  // },
  {
    path: "/domino/snow",
    element: <DominoApp words={wordsSnow} />,
    children: [],
  },  
  {
    path: "/domino/race",
    element: <DominoApp words={wordsRace} />,
    children: [],
  },
  {
    path: "/domino/space",
    element: <DominoApp words={wordsSpace} />,
    children: [],
  },
  {
    path: "/domino/devices",
    element: <DominoApp words={wordsDevices} />,
    children: [],
  },
  {
    path: "/domino/algorithm",
    element: <DominoApp words={wordsAlgorithm} />,
    children: [],
  },


  {
    path: "/stripes/d1/devices",
    element: (
      <StripesApp
        difficulty={1}
        pictureSet={PictureSet.DEVICES}
        restart={true}
      />
    ),
    children: [],
  },
  {
    path: "/stripes/d2/devices",
    element: (
      <StripesApp
        difficulty={2}
        pictureSet={PictureSet.DEVICES}
        restart={true}
      />
    ),
    children: [],
  },
  {
    path: "/stripes/d3/devices",
    element: (
      <StripesApp
        difficulty={3}
        pictureSet={PictureSet.DEVICES}
        restart={true}
      />
    ),
    children: [],
  },
  {
    path: "/stripes/d1/rules",
    element: (
      <StripesApp difficulty={1} pictureSet={PictureSet.RULES} restart={true} />
    ),
    children: [],
  },
  {
    path: "/stripes/d2/rules",
    element: (
      <StripesApp difficulty={2} pictureSet={PictureSet.RULES} restart={true} />
    ),
    children: [],
  },
  {
    path: "/stripes/d3/rules",
    element: (
      <StripesApp difficulty={3} pictureSet={PictureSet.RULES} restart={true} />
    ),
    children: [],
  },

  {
    path: "/stripes/d2/year3_lesson7",
    element: (
      <StripesApp
        difficulty={2}
        pictureSet={PictureSet.YEAR3_LESSON7}
        restart={true}
      />
    ),
    children: [],
  },



  {
    path: "/pyramid/c2/acrobat",
    element: <PyramidApp characterCount={2} gameStyle={"acrobat"} />,
    children: [],
  },
  {
    path: "/pyramid/c3/acrobat",
    element: <PyramidApp characterCount={3} gameStyle={"acrobat"} />,
    children: [],
  },
  {
    path: "/pyramid/c4/acrobat",
    element: <PyramidApp characterCount={4} gameStyle={"acrobat"} />,
    children: [],
  },
  {
    path: "/pyramid/c2/animal",
    element: <PyramidApp characterCount={2} gameStyle={"animal"} />,
    children: [],
  },
  {
    path: "/pyramid/c3/animal",
    element: <PyramidApp characterCount={3} gameStyle={"animal"} />,
    children: [],
  },


  {
    path: "/pyramid/191026",
    element: <PyramidApp characterCount={3} gameStyle={"animal"} />,
    children: [],
  },

  {
    path: "/pyramid/c4/animal",
    element: <PyramidApp characterCount={4} gameStyle={"animal"} />,
    children: [],
  },
  //animal family
  {
    path: "/carrier/animal",
    element: <CarrierApp GameStyle={"animal"} />,
    children: [],
  },


  {
    path: "/carrier/191026",
    element: <CarrierApp GameStyle={"animal"} />,
    children: [],
  },


  {
    path: "/carrier/family",
    element: <CarrierApp GameStyle={"family"} />,
    children: [],
  },
  ...vodyanoyRoutes,
  {
    path: "/flowchart",
    element: (
      <FlowchartProvider>
        <FlowchartApp />
      </FlowchartProvider>
    ),
    children: [],
  },



  {
    path: "/chart191026",
    element: (
      <FlowchartProvider>
        <FlowchartApp />
      </FlowchartProvider>
    ),
    children: [],
  },



  {
    path: "/hotel/orbital/1",
    element: <HotelApp GameStyle={"orbital"} Person = {1}/>,
    children: [],
  },
  {
    path: "/hotel/orbital/2",
    element: <HotelApp GameStyle={"orbital"} Person = {2}/>,
    children: [],
  },
  {
    path: "/hotel/orbital/3",
    element: <HotelApp GameStyle={"orbital"} Person = {3}/>,
    children: [],
  },
  {
    path: "/hotel/orbital/4",
    element: <HotelApp GameStyle={"orbital"} Person = {4}/>,
    children: [],
  },
  {
    path: "/hotel/orbital/5",
    element: <HotelApp GameStyle={"orbital"} Person = {5}/>,
    children: [],
  },
  {
    path: "/hotel/orbital/6",
    element: <HotelApp GameStyle={"orbital"} Person = {6}/>,
    children: [],
  },
  {
    path: "/hotel/adress/1",
    element: <HotelApp GameStyle={"adress"} Person = {1}/>,
    children: [],
  },
  {
    path: "/hotel/adress/2",
    element: <HotelApp GameStyle={"adress"} Person = {2}/>,
    children: [],
  },
  {
    path: "/hotel/adress/3",
    element: <HotelApp GameStyle={"adress"} Person = {3} />,
    children: [],
  },
  {
    path: "/hotel/adress/4",
    element: <HotelApp GameStyle={"adress"} Person = {4} />,
    children: [],
  },


  {
    path: "/hotel/191026",
    element: <HotelApp GameStyle={"adress"} Person = {4} />,
    children: [],
  },

  
  {
    path: "/hotel/adress/5",
    element: <HotelApp GameStyle={"adress"} Person = {5} />,
    children: [],
  },
  {
    path: "/hotel/adress/6",
    element: <HotelApp GameStyle={"adress"} Person = {6} />,
    children: [],
  },
  {
    path: "/sudoku/easy",
    element: <SudokuApp level={SudokuLevel.easy} />,
    children: [],
  },
  {
    path: "/sudoku/medium",
    element: <SudokuApp level={SudokuLevel.medium} />,
    children: [],
  },
  {
    path: "/sudoku/hard",
    element: <SudokuApp level={SudokuLevel.hard} />,
    children: [],
  },

  // Press Ctrl + left‑click the mouse to change the task.
  // /crypto/1
  ...cryptoRoutes,

  // /transpos/1/help
  ...transposRoutes,
  
  // /TablesSecret/1/1
  ...tablesSecretRouts,

  // /navigator/1/1
  ...navigatorСodeRoutes,

  // /caesar/1 or /caesar/2/r
  ...caesarСipherRoutes,
  
  // {
  //   path: "file",
  //   element: (
  //     <RequireAuth>
  //       <FileWindow />
  //     </RequireAuth>
  //   ),
  //   children: [
  //     {
  //       path: "resource/one/:resourceId",
  //       element: <ResourceWindow />,
  //       loader: async ({ params }: { params: Params<string> }) => {
  //         if (isId(params.resourceId)) {
  //           return defer({
  //             getResourceWithContentPromise:
  //               appStore.resourceStore.loadResourceWithContentAsync(
  //                 params.resourceId
  //               ),
  //           });
  //         }
  //       },
  //     },
  //   ],
  // },
]);

const AppStoresContext = React.createContext(appStore);

export const useStores = () => React.useContext(AppStoresContext);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    {/* <ErrorBoundary fallback={<div>Упс... Что-то пошло не так.</div>}> */}
    <AuthProvider>
      <AppStoresContext.Provider value={appStore}>
        <RouterProvider router={router} />
      </AppStoresContext.Provider>
    </AuthProvider>
    {/* </ErrorBoundary> */}
  </React.StrictMode>,
);

// Error handling
window.onerror = function (message, source, lineno, colno, error) {
  console.error(`Error: ${message} in ${source}:${lineno}:${colno}`);
  console.error(error);
  return true;
};

// Wrapper for requestAnimationFrame with try catch
(function () {
  const originalRequestAnimationFrame = window.requestAnimationFrame;

  window.requestAnimationFrame = function (callback: any) {
    return originalRequestAnimationFrame(function () {
      try {
        callback();
      } catch (e) {
        console.error("Error in requestAnimationFrame:", e);
      }
    });
  };
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
